import { FETCH_COMPANIES_REQUEST, SHOW_COMPANIES, SIGNUP_REQUEST } from './ActionTypes';

export const SignUpRequest = (signUpBody, callback) => {
  return {
    type: SIGNUP_REQUEST,
    signUpBody: signUpBody,
    callback: callback,
  };
};
export const fetchCompanies = (callback = () => {
}) => {
  return {
    type: FETCH_COMPANIES_REQUEST,
    callback,
  };
};

export const showCompanies = (companiesArray) => {
  return {
    type: SHOW_COMPANIES,
    companiesArray: companiesArray,
  };
};
